import SuperFetch from '../helpers/superFetch';
import UrlBuilder from '../helpers/urlBuilder';

const { build } = UrlBuilder;

type ParamsReq = (params: any) => Promise<Response>;
type RequestWithNoParam = () => Promise<Response>;

/**
 *
 * Klasa zawiera metody służące zapytaniom dla elementów globalnych aplikacji np. modali
 *
 */
class AppConfig {
  /** Zapytanie o historię zmian ocen */
  getChangeLog: ParamsReq = ({ kartaPrzedmiotId, kodPrzedmiotu, columns, limit }) => {
    const params = {
      columns,
      limit,
    };
    const address: string = build(`oceny/historia-ocen/${kartaPrzedmiotId}/${kodPrzedmiotu}`, params);
    return SuperFetch.get(address);
  };

  /** Zapytanie o listę nauczycieli */
  getInstructors: ParamsReq = ({ limit }) => {
    const address: string = build(`user/pracownicy`, { limit });
    return SuperFetch.get(address);
  };

  /** Zapytanie o aktualny status api */
  checkApiStatus: RequestWithNoParam = () => SuperFetch.get('status');

  /** Zapytanie o listę powiadomień wprowadzonych w panelu admina */
  getNotificationListAdmin: RequestWithNoParam = () => SuperFetch.get('adminpanel/notification-display');
}

export default new AppConfig();
